import { render, staticRenderFns } from "./PageColumnWithSupplierEditor.vue?vue&type=template&id=31fbf338&lang=pug&"
import script from "./PageColumnWithSupplierEditor.vue?vue&type=script&lang=ts&"
export * from "./PageColumnWithSupplierEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PageColumnWithSupplierEditor.vue?vue&type=style&index=0&id=31fbf338&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports